module.exports = __webpack_public_path__ + "static/img/43-2.96a62b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/43-2.jpg
// module id = PEoy
// module chunks = 0